import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Box, Flex } from "../box";
import { Button } from "../button";
import CloseButton from "../CloseButton";
import { Image } from "../image";
import { Input } from "../input";
import { Text } from "../typography";
import FilestackDropPane from "./FilestackDropPane";
import { FILESTACK_INLINE_CONTAINER_ID, IImageUploadProps, TImageData } from "./misc";

export default function ImageUploadDropPane({ onSave, imageData, onCancel, options }: IImageUploadProps) {
  const intl = useIntl();
  const [data, setData] = useState<TImageData>({
    url: imageData ? imageData.url : "",
    alt: imageData ? imageData.alt : "",
  });

  return (
    <Flex direction="column" alignItems="center">
      <Flex direction="column" alignItems="center" justifyContent="center" minHeight="120px">
        {data.url && (
          <Box position="relative" width="100%">
            <Image src={data.url} width="100%" borderRadius="md" alt={data.alt} objectFit="contain" />
            <CloseButton
              size="md"
              position="absolute"
              right={-6}
              top={-6}
              color="white"
              bg="red.500"
              borderRadius={25}
              _hover={{ bg: "red.600" }}
              onClick={() => setData({ url: "", alt: data.alt })}
            />
          </Box>
        )}

        {!data.url && (
          <Box id={FILESTACK_INLINE_CONTAINER_ID} width="100%" cursor="pointer">
            <FilestackDropPane
              options={options}
              onSuccess={({ filesUploaded }) => {
                if (filesUploaded[0]) {
                  setData({
                    url: filesUploaded[0].url,
                    alt: data.alt,
                  });
                }
              }}
            />
          </Box>
        )}
      </Flex>

      <Text fontSize="md" mt={3} alignSelf="start">
        <FormattedMessage defaultMessage="Image url" id="pJPAqG" />
      </Text>

      <Input
        type="text"
        size="sm"
        mt={1}
        value={data.url}
        onChange={(event) => setData({ url: event.target.value, alt: data.alt })}
        placeholder={intl.formatMessage({ defaultMessage: "Type image url...", id: "Z+gDIT" })}
      />

      <Text fontSize="md" mt={3} alignSelf="start">
        <FormattedMessage defaultMessage="Image alt text" id="9XYB+I" />
      </Text>

      <Input
        type="text"
        size="sm"
        mt={1}
        value={data.alt}
        onChange={(event) => setData({ url: data.url, alt: event.target.value })}
        placeholder={intl.formatMessage({ defaultMessage: "Type image alt...", id: "MGSkbi" })}
      />

      <Box mt={3} mb={2} alignSelf="start">
        <Button variant="primary" onClick={() => onSave(data)} size="sm" disabled={!data.url || !data.alt}>
          <FormattedMessage defaultMessage="Save" id="jvo0vs" />
        </Button>
        {onCancel && (
          <Button ml={2} variant="secondary" onClick={onCancel} size="sm">
            <FormattedMessage defaultMessage="Cancel" id="47FYwb" />
          </Button>
        )}
      </Box>
    </Flex>
  );
}
